/* eslint-disable react-hooks/exhaustive-deps */
import isEmpty from 'lodash/isEmpty'
import { useEffect } from "react";
import { useAppStore } from "../../../store/models/app";

function useOAuthFlow () {
    const appStore = useAppStore();
    useEffect(() => {
        appStore.init();
        // This setTimeout is to ensure that all the launchOauthPage() settings are in place.
        // verify linked in this could be use on linked in
        /*
        setTimeout(() => { 
            const flags = appStore.flags;
            const iosSafari = flags.ios && flags.safari;
            if (!iosSafari) {
                appStore.initWithSession();
                appStore.initAsOAuth(); 
            }     
        }, 2000);
        */
    }, []);

    useEffect(() => {
        if (!isEmpty(appStore.env.oauthSession)) {
            appStore.initWithSession();
            appStore.initAsOAuth();
        }
    }, [appStore.observed.oauthSession]);

    /*
    useEffect(() => {
        const flags = appStore.flags;
        console.log('useOAuthFlow sessionReady.. ', flags);
        if (appStore.observed.oauthSessionReady) {
            appStore.initWithSession();
            appStore.initAsOAuth();
        }
    }, [appStore.observed.oauthSessionReady]);
    */

    return {
        launcOauth: () => appStore.launchOauthPage(),
    };
}

export default useOAuthFlow;
